module.exports = __webpack_public_path__ + "static/media/black-friday.4ca27050.png";